<template>
  <div>
    <e-modal modal-id="change-password">
      <div slot="title">Change password for {{ eUser.username }}</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-12">
            <input type="password" placeholder="Password" v-model="password['pass']" class="form-control" @keydown.enter="updatePassword">
          </div>
          <div class="col-lg-12 m-t-xs m-b-xs">
            <input type="password" placeholder="Retype Password" v-model="password['retype']" class="form-control" @keydown.enter="updatePassword">
          </div>
          <div class="col-lg-12">
            <button class="btn-primary btn btn-xs" @click="updatePassword">Save</button>
          </div>
        </div>
      </div>
    </e-modal>
    <div v-if="eUser">
      <div class="row m-b-lg m-t-lg wrapper">
        <div class="col-md-12">
          <button class="btn btn-primary btn-sm pull-right" data-toggle="modal" data-target="#change-password">Change Password</button>
          <h3>{{ eUser.name }}</h3>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Name</td>
                  <td>
                    <e-txt
                      type="editable"
                      :text="eUser.name"
                      @input="updateProperty($event, 'name')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>Username</td>
                  <td>
                    {{ eUser.username }}
                  </td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>
                    <e-txt
                      type="editable"
                      :text="eUser.email"
                      @input="updateProperty($event, 'email')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr  v-if="eUser.id !== user.id">
                  <td>Groups</td>
                  <td>
                    <v-select
                      multiple
                      :options="f.groups"
                      v-model="eUser.groups"
                      label="name"
                      @input="updateProperty($event.map(g => g.id), 'groups')"
                    >
                    </v-select>
                  </td>
                </tr>
                <tr v-if="eUser.id !== user.id">
                  <td>Active</td>
                  <td>
                    <e-txt
                      type="select"
                      :text="eUser.active"
                      :selectedValue="eUser.active ? 'true' : 'false'"
                      :options="[{val: 'false', label: 'No'}, {val: 'true', label: 'Yes'}]"
                      selectLabel="label"
                      selectValue="val"
                      @input="updateProperty($event === 'true' ? 1 : 0, 'active')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import EditText from '../../../Helpers/Form/EditText'
import axios from 'axios'
import Form from '../../../Helpers/Modal/Form'

export default {
  data () {
    return {
      password: {}
    }
  },
  props: ['eUser'],
  computed: {
    ...mapGetters({
      f: 'getFilters',
      user: 'getUser',
      userRoles: 'getUserRoles'
    })
  },
  components: {
    eTxt: EditText,
    eModal: Form
  },
  mounted () {
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
    this.loaded = true
  },
  methods: {
    updateProperty (val, prop) {
      let data = {}
      data[prop] = val

      axios.patch(`/client/user/${this.eUser.id}`, data)
        .then(r => {
          this.eUser = r.data.data
          this.$toastr.success(`${prop} updated successfully`, 'Good')
          this.$forceUpdate()
        })
        .catch(e => {
          this.$toastr.error(e, 'Unable to update')
        })

      return true
    },
    updatePassword () {
      if (this.password.pass.length < 6) {
        this.$toastr.error('Please at least put some effort in it and make it at least 6 chars long. Ok? Thanks *sigh*', 'Password too short')
        return
      }
      if (this.password.pass !== this.password.retype) {
        this.$toastr.error('Passwords don\'t match', 'No can\'t do')
        return
      }

      axios.patch(`/user/${this.eUser.id}/password`, {
        password: this.password.pass,
        retype: this.password.retype
      })
        .then(r => {
          this.$toastr.success('Password changed successfully')
          $('#change-password').modal('hide')
          this.password = {}
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/ClientAccount/User/Header.vue